import { resizeObservers as r } from "../utils/resizeObservers.js";
import { calculateDepthForNode as i } from "./calculateDepthForNode.js";
var n = function(t) {
  r.forEach(function(e) {
    e.activeTargets.splice(0, e.activeTargets.length), e.skippedTargets.splice(0, e.skippedTargets.length), e.observationTargets.forEach(function(s) {
      s.isActive() && (i(s.target) > t ? e.activeTargets.push(s) : e.skippedTargets.push(s));
    });
  });
};
export {
  n as gatherActiveObservationsAtDepth
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js
// module id = 1311
// module chunks = 41